import React, { Component } from "react";

export default class FullStackImg extends Component {
  render() {
    return (
      <svg
        id="fa973782-3a18-4630-a762-87130b613ac3"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="1120"
        height="829.80067"
        viewBox="0 0 1120 829.80067"
      >
        <title>Leading Team</title>

        {/* Embed the image here */}
        <image
          x="100"
          y="100"
          width="900"
          height="950"
          href="https://i.ibb.co/vDtRjFN/Untitled-design-4.png"
        />

        {/* Other SVG content remains the same */}
      </svg>
    );
  }
}
